import { IconName } from "~/components/ui/icon";
import { type TeamRole, TeamRoles } from "./roles";

export type LinkType = {
  name: string;
  to: string;
  iconName: IconName;
  teamRoles: TeamRole[];
};

export const headerLinks = [
  {
    item: "Altas",
    className:
      "grid gap-y-1 gap-x-3 p-4 md:w-[400px] lg:w-[750px] lg:grid-cols-3",
    teamRoles: [TeamRoles.ADMIN, TeamRoles.MANAGER, TeamRoles.MONITOR],
    links: [
      {
        name: "Productos",
        to: "/products",
        iconName: "flask-conical",
        description: "Alta y consulta de productos",
        teamRoles: [TeamRoles.ADMIN],
      },
      {
        name: "Destinos",
        to: "/destinations",
        iconName: "navigation",
        description: "Alta y consulta de destinos",
        teamRoles: [TeamRoles.ADMIN],
      },
      {
        name: "Proveedores",
        to: "/providers",
        iconName: "handshake",
        description: "Alta y consulta de proveedores",
        teamRoles: [TeamRoles.ADMIN],
      },
      {
        name: "Inventarios",
        to: "/inventories",
        iconName: "cylinder",
        description: "Alta y consulta de inventarios",
        teamRoles: [TeamRoles.ADMIN],
      },
      {
        name: "Terminales",
        to: "/terminals",
        iconName: "factory",
        description: "Alta y consulta de terminales",
        teamRoles: [TeamRoles.ADMIN],
      },
      {
        name: "Transportes",
        to: "/carriers",
        iconName: "truck",
        description: "Alta y consulta de transportes",
        teamRoles: [TeamRoles.ADMIN],
      },
      {
        name: "Rutas de entrega",
        to: "/delivery-routes",
        iconName: "waypoints",
        description: "Alta y consulta de rutas de entrega",
        teamRoles: [TeamRoles.ADMIN, TeamRoles.MANAGER, TeamRoles.MONITOR],
      },
    ] satisfies (LinkType & { description: string })[],
  },
  {
    item: "Utilidades",
    className: "grid gap-y-1 gap-x-3 p-4 md:w-[500px] lg:grid-cols-2",
    teamRoles: [TeamRoles.OPERATOR, TeamRoles.ADMIN],
    links: [
      {
        name: "Editor de imagenes",
        to: "/image-editor",
        iconName: "images",
        description: "Programa de retoque y edición de imágenes",
        teamRoles: [TeamRoles.OPERATOR, TeamRoles.ADMIN],
      },
    ],
  },
  {
    item: "Admin",
    className: "grid gap-y-1 gap-x-3 p-4 lg:w-[500px] lg:grid-cols-2",
    teamRoles: [TeamRoles.ADMIN],
    links: [
      {
        name: "Clientes",
        to: "/clients",
        iconName: "users",
        description: "Alta y consulta de clientes",
        teamRoles: [TeamRoles.ADMIN],
      },
      {
        name: "Usuarios",
        to: "/users",
        iconName: "user-pen",
        description: "Alta y consulta de usuarios",
        teamRoles: [TeamRoles.ADMIN],
      },
      {
        name: "Precios",
        to: "/prices",
        iconName: "dollar-sign",
        description: "Costos, cotizador y corrida",
        teamRoles: [TeamRoles.ADMIN],
      },
      {
        name: "Ajustes & Equipo",
        to: "/settings/general",
        iconName: "settings",
        description: "Configura tu experiencia",
        teamRoles: [TeamRoles.ADMIN],
      },
    ] satisfies (LinkType & { description: string })[],
  },
];

export const sidebarLinks = [
  {
    name: "Inicio",
    to: "/dashboard",
    iconName: "house",
    // @todo – Same can be achieve with the lowest "contributor",
    // just adding all to keep consistency. Change with clean up
    teamRoles: [
      // TeamRoles.ADMIN,
      // TeamRoles.MANAGER,
      // TeamRoles.MONITOR,
      // TeamRoles.CONTRIBUTOR,
      // TeamRoles.OPERATOR,
      TeamRoles.VIEWER,
    ],
  },
  // {
  //   name: "IA",
  //   to: "/ai",
  //   iconName: "sparkles",
  //   teamRoles: [TeamRoles.OWNER],
  // },
  {
    name: "Clientes",
    to: "/clients",
    iconName: "users",
    teamRoles: [TeamRoles.ADMIN],
  },
  {
    name: "Orden de compra",
    to: "/orders/purchases",
    iconName: "file-input",
    teamRoles: [TeamRoles.ADMIN],
  },
  {
    name: "Orden de venta",
    to: "/orders/sales",
    iconName: "file-output",
    teamRoles: [TeamRoles.ADMIN],
  },
  {
    name: "Productos",
    to: "/products",
    iconName: "flask-conical",
    teamRoles: [TeamRoles.ADMIN],
  },
  {
    name: "Proveedores",
    to: "/providers",
    iconName: "handshake",
    teamRoles: [TeamRoles.ADMIN],
  },
  {
    name: "Inventarios",
    to: "/inventories",
    iconName: "cylinder",
    teamRoles: [TeamRoles.ADMIN],
  },
  {
    name: "Terminales",
    to: "/terminals",
    iconName: "factory",
    teamRoles: [TeamRoles.OPERATOR, TeamRoles.ADMIN],
  },
  {
    name: "Precios",
    to: "/prices",
    iconName: "dollar-sign",
    teamRoles: [TeamRoles.ADMIN],
  },
  {
    name: "Entregas",
    to: "/deliveries",
    iconName: "signature",
    teamRoles: [TeamRoles.MONITOR, TeamRoles.MANAGER, TeamRoles.ADMIN],
  },
] satisfies LinkType[];

export const valhallaLinks = [
  {
    name: "Inicio",
    to: "/dashboard",
    iconName: "house",
    teamRoles: [TeamRoles.OWNER],
  },
] satisfies LinkType[];

export const quickLinks = [
  {
    name: "Productos",
    to: "/products",
    iconName: "flask-conical",
    teamRoles: [TeamRoles.ADMIN],
  },
  {
    name: "Clientes",
    to: "/clients",
    iconName: "users",
    teamRoles: [TeamRoles.ADMIN],
  },
  {
    name: "Orden de compra",
    to: "/orders/purchases",
    iconName: "file-input",
    teamRoles: [TeamRoles.ADMIN],
  },
  {
    name: "Orden de venta",
    to: "/orders/sales",
    iconName: "file-output",
    teamRoles: [TeamRoles.ADMIN],
  },
] satisfies LinkType[];
